import { IBufferMessage, MessageType } from '@augloop/schemas/dist/src/client/schemas';

export interface IPubSubMessage extends IBufferMessage {
    // Payload has type 'any' after deserializing IBufferMessage payload
    payload?: any;
    correlationVector?: any;
}

export const isExceptionMessage = (message: IPubSubMessage): boolean => {
    if (message == null || message.messageType == null) {
        return true;
    }

    return (message.messageType == MessageType.Exception);
};
